const specData = {
    to: 'vladimirkirus@gmail.com',
    subject: 'Тема письма!',
    html: '<h1>Привет!</h1><p>Это тестовое письмо с файлом.</p>',
};

const fileObj = {
    blob: 'blob',
    fileName: 'example.pdf',
    mimeType: { type: 'application/pdf' },
};

/**
 * Отправляет электронное письмо с вложением на указанный адрес.
 *
 * @param {Object} specData - Объект с информацией о письме.
 * @param {string} specData.to - Email-адрес получателя.
 * @param {string} specData.subject - Тема письма.
 * @param {string} specData.html - HTML-контент письма.
 *
 * @param {Object} [blobObj=null] - Объект с информацией о файле.
 * @param {Blob} [blobObj.blob] - Данные файла в формате Blob.
 * @param {string} [blobObj.fileName] - Имя файла.
 * @param {Object} [blobObj.mimeType] - MIME-тип файла.
 * @param {string} [blobObj.mimeType.type] - Строка MIME-типа, например, "application/pdf".
 *
 * @returns {void}
 */
export function sendMail(specData, blobObj = null) {
    const { to, subject, html } = specData;
    const formData = new FormData();
    formData.append('to', to);
    formData.append('subject', subject);
    formData.append('html', html);

    if (blobObj) {
        const { blob, fileName, mimeType } = fileObj;
        const file = new File([blobObj], fileName, mimeType);
        formData.append('attachment', file);
        console.log(file);
    }

    const TOKEN = '139e78a0-eb90-41db-8875-90f7d52ce873';
    const API_URL = 'https://zest-pro.ru/send-email';

    fetch(API_URL, {
        method: 'POST',
        body: formData,
        headers: {
            Authorization: `Bearer ${TOKEN}`,
        },
    });
}

export function createSpecData() {
    const form = document.getElementById('place-order-form');
    const formData = new FormData(form);
    const name = formData.get('place-order__name');
    const email = formData.get('place-order__email');
    const phone = formData.get('place-order__phone');
    const info = formData.get('place-order__info');
    const to = email;

    const subject = 'Спецификация плитки';
    const html = `
        <h1>Спецификация</h1>
        <p>Имя: ${name}</p>
        <p>Email: ${email}</p>
        <p>Телефон: ${phone}</p>
        <p>Информация: ${info}</p>
        `;

    return { to, subject, html };
}

export function validateForm() {
    // Получаем все необходимые элементы
    const nameInput = document.querySelector('input[name="place-order__name"]');
    const emailInput = document.querySelector('input[name="place-order__email"]');
    const phoneInput = document.querySelector('input[name="place-order__phone"]');
    const infoInput = document.querySelector('textarea[name="place-order__info"]');

    // Сбрасываем красные рамки, если они были
    resetValidationStyles([nameInput, emailInput, phoneInput, infoInput]);

    let isValid = true;

    // Проверка имени
    if (nameInput.value.trim() === '') {
        nameInput.style.border = '1rem solid red';
        isValid = false;
    }

    // Проверка email с помощью регулярного выражения
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Простая проверка email
    if (!emailPattern.test(emailInput.value.trim())) {
        emailInput.style.border = '1rem solid red';
        isValid = false;
    }

    // Проверка телефона
    if (phoneInput.value.trim() === '') {
        phoneInput.style.border = '1rem solid red';
        isValid = false;
    }

    // textarea (необязательное поле) не проверяем

    return isValid; // Возвращаем результат валидации
}

function resetValidationStyles(inputs) {
    inputs.forEach((input) => {
        input.style.border = ''; // Сбрасываем стиль рамки
    });
}
